import Normal from './Normal/Normal.vue'
import Carousel from './Carousel/Carousel'
import Card from './Card/Card.vue'
import CardList from './CardList/CardList.vue'
import Images from './Images/Images.js'
import Youtube from './Youtube/Youtube.vue'
import Videos from './Videos/Videos.vue'
import CiviiChatForm from '@/civii-chat/components/CiviiChatForm.vue'
import CiviiChatFeedback from '@/civii-chat/components/CiviiChatFeedback.vue'
import Select from './Select/Select.vue'
import Date from './Date/Date.vue'
import Collapse from './Collapse/Collapse.vue'

let answersDict = {
  Normal,
  Carousel,
  Card,
  CardList,
  Images,
  Youtube,
  Videos,
  CiviiChatForm,
  CiviiChatFeedback,
  Select,
  Date,
  Collapse
}

export default {
  components: answersDict,
  props: {
    answer: [Object, String]
  },
  render (createElement) {
    let answer = JSON.parse(JSON.stringify(this.answer))
    if (typeof answer === 'string') {
      answer = {
        type: 'Normal',
        side: 'left',
        messages: answer
      }
    }
    answer = Object.assign({}, answer)
    let type = answer.type
    delete answer.type
    return createElement(answersDict[type], { props: answer })
  }
}



// WEBPACK FOOTER //
// ./src/components/answers/AnswerBuilder.js